import { EnumMenu } from "../../model";
import { MenuModel } from '../../model/app';
import { EnumTipoUsuario } from "../../model/enums/enum-tipo-usuario";

export const ModulosAdminMock: MenuModel[] = [
  new MenuModel("Dashboard Admin", EnumMenu.DASHBOARD_ADMIN, [EnumTipoUsuario.EnumTipoAdm], "/dashboard-admin", 1)
]
